<template>
    <div class="common-page cart" v-if="!loading" style=" padding-bottom: 40px">
        <div class="wrapper">
            <h2>Carrinho</h2>
            <table v-if="$root.cart && $root.cart.items.length" class="cart-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Modelo</th>
                        <th>Categoria</th>
                        <th>Quantidade</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in $root.cart.items" v-bind:key="index">
                        <td>{{ index+ 1 }}</td>
                        <td><div style="display: flex; align-items: center;"><img v-if="item.file && item.file.url" :src="item.file.url" height="40">{{ item.shortName }} - {{ item.name }} <router-link :to="{path: '/maquina/'+item.uri}"><i class="ico-launchopen_in_new"></i></router-link></div></td>
                        <td>{{ item.category }}</td>
                        <td>
                            <div style="display: flex; align-items: center;">
                                <a @click="sub(item, index)"><i class="ico-indeterminate_check_box"></i></a>
                                {{ item.quantity }} 
                                <a @click="add(item)"><i class="ico-add_box"></i></a> 
                            </div>
                        </td>
                    </tr>
                </tbody>  
            </table>
            <div v-else style="text-align: center;padding: 40px;background: #fff;margin: 10px 0 10px 55px;">
                <h2>Seu carrinho está vazio.</h2>
                <p>Adicione um novo equipamento para cotar</p>
            </div>
            <div class="buttons"> 
                <router-link to="/maquinas" v-if="!$root.cart || !$root.cart.items.length" tag="button" class="button" style="margin: 15px 15px 15px 0">Encontrar equipamento </router-link>
                <router-link to="/maquinas" v-if="$root.cart && $root.cart.items.length" tag="button" class="button" style="margin: 15px 15px 15px 0">Adicionar mais</router-link>
                <button type="button" @click="sendRequest()" v-if="$root.cart && $root.cart.items.length" class="button" style="margin: 15px 15px 15px 0">Solicitar orçamento</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Cart",
    data(){
        return {
            loading: false,
            processing: false
        }
    },
    created(){
        this.loading = false
    },
   
    methods: {
        add(item){
            ++item.quantity
            this.$root.updated = true
        },
        sub(item, index){ 
            if(item.quantity == 1){
                this.$delete(this.$root.cart.items, index)
            }
            else{
                --item.quantity
            }
            this.$root.updated = true
        },
        sendRequest(){
            this.processing = true
            let order = this.$root.cart
            delete order.docID
            order.createdOn = this.$moment().format('X')
            order.status = {
                id: 1,
                label: 'waiting_quotation'
            }
            this.$db.collection('orders').add(order).then(() => {
                this.$root.updated = false
                this.processing = false
                this.$root.alerts.push({msg: 'Orçamento efetuado com sucesso', type: 'success'})
                this.$root.cart.items = []
                this.$root.updated = true
            }).catch((err) => {
                this.processing = false
                this.$root.updated = false
                console.log(err)
                    this.$root.alerts.push({msg: 'Erro ao salvar o efetuar orçamento', type: 'error'})
                    this.loading = false
            })
        }
    }
}
</script>
<style scoped>
    .cart-table a{
        padding: 5px !important;
        font-size: 1.2em;
        text-decoration: none;
        color: #32499b;
    } 
</style> 